export function getImagePath(name, type = '',  need = true,abs = '' ,) {
	if(need){}
	if(type=='.mp3' || type == '.wav'){
		return `${name}${type}`;
	}else{
		return `${abs}static/${name}${type}`;
	}

}



// WEBPACK FOOTER //
// ./src/config/imgConfig.js